import React, {FC} from 'react';
import { BoundSearchQuery } from "../../../types/common/BoundSearchQuery";
import { AdminPayoutSearchCriteria } from "../../../types/model/criteria/payout/AdminPayoutSearchCriteria";
import { PageableParams } from "../../../types/model/params/PageableParams";
import { optionsEndpoints } from "../../../requests/api-endpoints";
import {
  SortFilterContainer,
  SortFilterItemContainer,
  SortFilterRowContainer
} from "../../common/reports/sortFilter";
import {
  sortByFields,
  AdminPayoutSortByType,
  AdminPayoutSortParams
} from "../../../types/model/params/sortParams/AdminPayoutSortParams";
import {
  BoundSortSelect,
  BoundDataDrivenAutocomplete,
  BoundDataDrivenSelect,
  BoundDateRangeFilter
} from "../../common/inputs/boundInputs";

export interface AdminPayoutsSearchParams extends AdminPayoutSearchCriteria, AdminPayoutSortParams, PageableParams, BoundSearchQuery {}

export interface AdminPayoutsSortFilterProps {
  query: AdminPayoutsSearchParams;
  onChange: (newQuery: AdminPayoutsSearchParams) => void;
}

const AdminPayoutsSortFilter: FC<AdminPayoutsSortFilterProps> = ({
  query,
  onChange
}) => {

  return <SortFilterContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<AdminPayoutsSearchParams>
          label="Location"
          requestUrl={optionsEndpoints.admin.location}
          name="locationId"
          value={query?.locationId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<AdminPayoutsSearchParams>
          label="Supplier"
          requestUrl={optionsEndpoints.admin.account.supplier}
          name="supplierAccountId"
          value={query?.supplierAccountId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <BoundDateRangeFilter<AdminPayoutsSearchParams>
        query={query}
        onChange={onChange}
      />
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenSelect<AdminPayoutsSearchParams>
          label="Status"
          requestUrl={optionsEndpoints.admin.payouts.statuses}
          name="status"
          value={query?.status}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundSortSelect<AdminPayoutsSearchParams, AdminPayoutSortByType>
          query={query}
          defaultSortBy="CREATED_ON"
          defaultSortDir="desc"
          sortByFields={sortByFields}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
  </SortFilterContainer>
}

export { AdminPayoutsSortFilter };
